import { useState } from "react";
import Footer from "../../components/Footer/Footer";
import { useQuery } from "convex/react";
import { Link } from "react-router-dom";

function Schedule() {
  const [activeTab, setActiveTab] = useState("Monday");
  const scheduleData = useQuery("schedule:get") || [];

  const days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const filteredSchedule = scheduleData.filter((item) => item.day === activeTab);

  return (
    <>
      <section className="bg-black pt-[15rem] min-h-screen">
        <div className="login-banner relative justify-center flex">
          <h1 className="text-white absolute bottom-[25px] text-[3rem] font-bold">
            Schedule
          </h1>
        </div>

        <div className="container page-padding py-[5rem]">
          {/* filter buttons */}
          <div className="flex flex-wrap gap-4 justify-center mb-[5rem]">
            {days.map((day) => (
              <button
                key={day}
                onClick={() => setActiveTab(day)}
                className={`text-[15px] font-bold border-solid border border-[#d7d7d7] py-[9px] px-[32px] rounded-[23px] ease-in duration-200 hover:shadow-2xl ${
                  activeTab === day
                    ? "bg-[#ff0336] text-white border-[#ff0336]"
                    : "text-white hover:bg-[#ff0336] hover:text-white"
                }`}
              >
                {day}
              </button>
            ))}
          </div>

          {/* content */}
          <div className="mt-[5rem] flex flex-col gap-4">
            {filteredSchedule.length > 0 ? (
              filteredSchedule.map((item, index) => (
                <div 
                  key={index} 
                  className="bg-[#1a1a1a] p-12 rounded-3xl border border-gray-800 flex justify-between items-center md700:flex-col md700:gap-8 min-h-[120px] hover:border-[#ff0336] transition-colors"
                >
                  <div className="flex flex-col gap-2">
                    <p className="text-gray-400 text-[1.40rem] font-medium">Session Name</p>
                    <p className="text-white text-[2rem] font-bold uppercase">{item.className}</p>
                  </div>
                  <div className="flex flex-col gap-2">
                    <p className="text-gray-400 text-[1.40rem] font-medium">Time</p>
                    <p className="text-white text-[2rem] font-bold uppercase">{item.time}</p>
                  </div>
                  <div className="flex flex-col gap-2">
                    <p className="text-gray-400 text-[1.40rem] font-medium">Trainer</p>
                    <p className="text-white text-[2rem] font-bold uppercase">{item.trainer}</p>
                  </div>
                  <Link 
                    to="/contact"
                    onClick={() => window.scrollTo(0, 0)}
                    className="bg-[#555] text-white py-3 px-10 rounded-[23px] text-[1.4rem] font-bold uppercase hover:bg-[#ff0336] transition-colors"
                  >
                    Join Now
                  </Link>
                </div>
              ))
            ) : (
              <div className="flex flex-col items-center justify-center py-20 bg-[#1a1a1a] rounded-3xl border border-gray-800 border-dashed">
                <p className="text-[#ff0336] text-[2rem] font-bold uppercase tracking-widest opacity-40">No Sessions Scheduled</p>
                <p className="text-gray-500 text-[1.4rem] mt-2 italic">Sessions for {activeTab} will be announced soon!</p>
              </div>
            )}
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
}

export default Schedule;
